/**
 * For impressions and clicks, 0-2 decimal places
 */
export const impreAndClicksOptions = {
  compact: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

/**
 * For no decimals, 0 decimal places
 */
export const noDecimalOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const formatBigDecimal = (value, i18n) => {
  if (value > 999999) {
    return i18n.formatDecimal(value, impreAndClicksOptions);
  }
  return i18n.formatDecimal(value, noDecimalOptions);
};
